(ns core.permission.resolver
  ;; clj-kondo does not realize that this is only required for clj, not cljs
  #_{:clj-kondo/ignore #?(:cljs [:unused-namespace] :clj [])}
  (:require #?(:clj [core.permission.core :as perm])
            #?(:cljs [clojure.set :as set])
            #?(:cljs [core.permission.model :as perm-model])))

#_{:clj-kondo/ignore #?(:cljs [:unused-binding] :clj [])}
(defn permissions
  "Returns a seq of permission keywords the given subject has for given
  target. Both the target and the subject must be an entities when called in CLJ code.
  In CLJS code only the :granted-permissions key is checked for the entity."
  [target subject]
  #?(:clj  (perm/permissions target subject)
     :cljs (-> target :granted-permissions)))

(defn permitted? [target subject permission]
  #?(:clj  (perm/permitted? target subject permission)
     :cljs (let [reqd-permissions (set (perm-model/coerce-required-permissions permission))]
             (= reqd-permissions
                (set/intersection reqd-permissions (set (permissions target subject)))))))
